import React, { useState } from "react";
import { Div, DownloadIcon, DeleteIcon } from "components/Base";
import DeleteConfirmationPopover from "./DeleteConfirmationPopover.js";
import { canAdminUserDeleteContent } from "../selectors.js";

import { connect } from "react-redux";
import { actions } from "../model.js";

const decorate = connect(
  state => ({
    canAdminUserDeleteContent: canAdminUserDeleteContent(state)
  }),
  {
    downloadFile: actions.downloadFile,
    deleteFile: actions.deleteFile
  }
);

const UploadContentMenu = ({
  fileId,
  downloadFile,
  deleteFile,
  canAdminUserDeleteContent
}) => {
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);
  return (
    <Div
      display="flex.flex-start.center"
      bg="white"
      style={{ gap: 8 }}
      width={1}
      flex={1}
    >
      <Div
        display="flex.center.center"
        onClick={() => {
          downloadFile(fileId);
        }}
      >
        <DownloadIcon color={{ default: "#494949", hover: "#999" }} size={14} />
      </Div>

      {canAdminUserDeleteContent ? (
        <DeleteConfirmationPopover
          onClose={() => setConfirmIsOpen(false)}
          onLabelClick={() => {
            setConfirmIsOpen(!confirmIsOpen);
          }}
          isOpen={confirmIsOpen}
          onConfirm={() => {
            deleteFile(fileId);
            setConfirmIsOpen(false);
          }}
          Label={
            <Div
              display="flex.center.center"
              onClick={() => {
                setConfirmIsOpen(!confirmIsOpen);
              }}
            >
              <DeleteIcon
                color={{ default: "#494949", hover: "#999" }}
                size={14}
              />
            </Div>
          }
          styleMenu={{
            right: "unset",
            width: "170px"
          }}
        ></DeleteConfirmationPopover>
      ) : null}
    </Div>
  );
};

export default decorate(UploadContentMenu);
